import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApplicationComponent } from './components/application/application.component';
import { ModuleMenuComponent } from './components/toolbar/module-menu/module-menu.component';
import { NotificationComponent } from './components/toolbar/notification/notification.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatBadgeModule } from '@angular/material/badge';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import { SigninUserComponent } from './components/toolbar/signin-user/signin-user.component';
import { SigninComponent } from './components/signin/signin.component';
import { RegisterUserComponent } from './components/register-user/register-user.component';
import { ToolbarCompanyComponent } from './components/toolbar/toolbar-company/toolbar-company.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppHttpInterceptorService } from './services/app-http-interceptor.service';
import { AppInitializerService } from './services/app-initializer.service';
import {DialogComponent} from './util/dialog/dialog.component';
import {MsgboxComponent} from './util/msgbox/msgbox.component';
import {ToastmsgComponent} from './util/toastmsg/toastmsg.component'
import { UserInfoService } from './services/user-info.service';
import { TabComponent } from './components/tab/tab.component';
import { FlightlistComponent } from './components/flightlist/flightlist.component';
import {MaterialModule} from './material/material.module';
import { UserComponent } from './components/user/user.component';
import { RoleComponent } from './components/role/role.component';
import { WorkInProgressComponent } from './components/work-in-progress/work-in-progress.component';
import { ActivityControlsComponent } from './components/activity-controls/activity-controls.component';
import { ColorTextSettingsComponent } from './components/color-text-settings/color-text-settings.component';
import { FlightComponent } from './components/flight/flight.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UserUpdateComponent } from './components/user-update/user-update.component';
import { TerminalComponent } from './components/terminal/terminal.component';
import { TicketIssuanceComponent } from './components/ticket-issuance/ticket-issuance.component';
import { ConfigComponent } from './components/config/config.component';
import { AirConfigComponent } from './components/air-config/air-config.component';
import { UserConfigComponent } from './components/user-config/user-config.component';
import { AirManagementComponent } from './components/air-management/air-management.component';
import { AmadeusComponent } from './components/amadeus/amadeus.component';
import { BookingMenuListComponent } from './components/booking-menu-list/booking-menu-list.component';
import { BookingComponent } from './components/booking/booking.component';
import { PaymentConfigComponent } from './components/payment-config/payment-config.component';
import { DataEncryptionComponent } from './components/data-encryption/data-encryption.component';
import { DataSecurityComponent } from './components/data-security/data-security.component';
import { PaymentMediumComponent } from './components/payment-medium/payment-medium.component';
import { PaymentDepositsComponent } from './components/payment-deposits/payment-deposits.component';
import { HotelComponent } from './components/hotel/hotel.component';
import { ReportingConfigComponent } from './components/reporting-config/reporting-config.component';
import { PaymentDetailsComponent } from './components/payment-details/payment-details.component';
import { CommercialsComponent } from './components/commercials/commercials.component';
import { TestComponent } from './components/test/test.component';
import { FaresRulesConfigComponent } from './components/fares-rules-config/fares-rules-config.component';
import { ManageCartsComponent } from './components/manage-carts/manage-carts.component';
import { ModifyCartComponent } from './components/modify-cart/modify-cart.component';
import { CartStatusComponent } from './components/cart-status/cart-status.component';
import { HotelListComponent } from './components/hotel-list/hotel-list.component';
import { RbdComponent } from './components/rbd/rbd.component';
import { HotelDetailsComponent } from './components/hotel-details/hotel-details.component';
import { IataCommissionComponent } from './components/iata-commission/iata-commission.component';
import { MulitiCityFlightlistComponent } from './components/muliti-city-flightlist/muliti-city-flightlist.component';
import { PnrRetriveComponent } from './components/pnr-retrive/pnr-retrive.component';
import { ManualCartComponent } from './components/manual-cart/manual-cart.component';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DialogModule } from 'primeng/dialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RatingModule } from 'primeng/rating';
import { CheckboxModule } from 'primeng/checkbox';
import { SliderModule } from 'primeng/slider';
import { KeyFilterModule } from 'primeng/keyfilter';
import { DataViewModule } from 'primeng/dataview';
import { DockModule } from 'primeng/dock';
import { MenuModule } from 'primeng/menu';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { TabViewModule } from 'primeng/tabview';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { BadgeModule } from 'primeng/badge';

import { SplitterModule } from 'primeng/splitter';

import { EditorModule } from 'primeng/editor';

import { StyleClassModule } from 'primeng/styleclass';
import { FileUploadModule } from 'primeng/fileupload';
import { MealsComponent } from './components/meals/meals.component';
import { HotelBookingComponent } from './components/hotel-booking/hotel-booking.component';
import { MilesComponent } from './components/miles/miles.component';
import { HotelPaymentDetailComponent } from './components/hotel-payment-detail/hotel-payment-detail.component';
import { GeneratePnrComponent } from './components/generate-pnr/generate-pnr.component';
import { ResetPasswdComponent } from './components/reset-passwd/reset-passwd.component';
import { AirportsComponent } from './components/airports/airports.component';
import { RaisedTicketComponent } from './components/raised-ticket/raised-ticket.component';
import { ManualBookingComponent } from './components/manual-booking/manual-booking.component';
import { ManualPaymentDetailComponent } from './components/manual-payment-detail/manual-payment-detail.component';
import { BranchComponent } from './components/branch/branch.component';
import { SkeletonModule } from 'primeng/skeleton';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { GoogleMapsModule } from '@angular/google-maps';
// import { HotelConfigComponent } from './components/hotel-config/hotel-config.component';
import { AgentDashboardComponent } from './components/agent-dashboard/agent-dashboard.component';
import { OffersComponent } from './components/offers/offers.component';
// import { SplitButtonModule } from 'primeng/splitbutton';
import { QRCodeModule } from 'angularx-qrcode';
import { AgentPaymentConfirmComponent } from './components/agent-payment-confirm/agent-payment-confirm.component';
import { AgentPaymentCancelComponent } from './components/agent-payment-cancel/agent-payment-cancel.component';
import { HotelModifyCartComponent } from './components/hotel-modify-cart/hotel-modify-cart.component';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule,NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { MmtRoomDetailComponent } from './components/mmt-room-detail/mmt-room-detail.component';
import { AgodaRoomDetailComponent } from './components/agoda-room-detail/agoda-room-detail.component';
import { MergeHotelDetailComponent } from './components/merge-hotel-detail/merge-hotel-detail.component';
import { HotelCommercialsComponent } from './components/hotel-commercials/hotel-commercials.component';
import { ManageFileUploadComponent } from './components/manage-file-upload/manage-file-upload.component';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { TripComponent } from './components/trip/trip.component';
import { DocSopComponent } from './components/doc-sop/doc-sop.component';
import { DocPolicyComponent } from './components/doc-policy/doc-policy.component';
import { TripSummaryComponent } from './components/trip-summary/trip-summary.component';
import { ManageExpenceComponent } from './manage-expence/manage-expence.component';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { DropdownModule } from 'primeng/dropdown';
import { ApproverDashboardComponent } from './components/approver-dashboard/approver-dashboard.component';
import { ApprovalTripComponent } from './components/approval-trip/approval-trip.component';
import { CalendarCartComponent } from './components/calendar-cart/calendar-cart.component';
// import { ServicesTabsComponent } from './components/services-tabs/services-tabs.component';
import { IntlFlightListComponent } from './components/intl-flight-list/intl-flight-list.component';
import { TripSearchRequestComponent } from './components/trip-search-request/trip-search-request.component';
import { BusComponent } from './components/bus/bus.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { HotelManualCartComponent } from './components/hotel-manual-cart/hotel-manual-cart.component';
import { BusinessGroupComponent } from './components/business-group/business-group.component';
// import { GilpinVisaComponent } from './components/gilpin-visa/gilpin-visa.component';
// import { AirQueueComponent } from './components/air-queue/air-queue.component';
import { TravelPoliciesComponent } from './components/travel-policies/travel-policies.component';
import { TravelDeskComponent } from './components/travel-desk/travel-desk.component';
import { HotelManualBookingComponent } from './components/hotel-manual-booking/hotel-manual-booking.component';
import { HotelManualPaymentDetailComponent } from './components/hotel-manual-payment-detail/hotel-manual-payment-detail.component';
import { HotelManagementComponent } from './components/hotel-management/hotel-management.component';
import { TagsCardComponent } from './components/tags-card/tags-card.component';
// import { MultiCityFlightlistComponent } from './components/multi-city-flightlist/multi-city-flightlist.component';
import { DropDownComponent } from './util/drop-down/drop-down.component';
import { InsuranceComponent } from './components/insurance/insurance/insurance.component';
import { InsuranceListComponent } from './components/insurance/insurance-list/insurance-list.component';
import { NotificationSettingsComponent } from './components/notification-settings/notification-settings.component';
import { InsuranceCommercialsComponent } from './components/insurance/insurance-commercials/insurance-commercials.component';
import { InsuranceBookingComponent } from './components/insurance/insurance-booking/insurance-booking.component';
import { InsurancePaymentDetailComponent } from './components/insurance/insurance-payment-detail/insurance-payment-detail.component';
import { PaymentContractComponent } from './components/payment-contract/payment-contract.component';
import { InsuranceModifyCartComponent } from './components/insurance/insurance-modify-cart/insurance-modify-cart.component';
import { NgSelectModule } from '@ng-select/ng-select';

const initializeApp = (userInfoService : UserInfoService) =>{
  return () => {
    const appInitializer : AppInitializerService = new AppInitializerService(userInfoService);
    appInitializer.load();
  }
}

const INIT_USERINFOSERVICE = new InjectionToken('UserInfoService');

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // ✅ Add this line to recognize Web Components

  declarations: [
    AppComponent,
    ApplicationComponent,
    ModuleMenuComponent,
    NotificationComponent,
    SigninUserComponent,
    SigninComponent,
    RegisterUserComponent,
    ToolbarCompanyComponent,
    DialogComponent,
    MsgboxComponent,
    ToastmsgComponent,
    TabComponent,
    UserComponent,
    RoleComponent,
    WorkInProgressComponent,
    ActivityControlsComponent,
    ColorTextSettingsComponent,
    FlightComponent,
    SettingsComponent,
    UserUpdateComponent,
    TerminalComponent,
    TicketIssuanceComponent,
    ConfigComponent,
    AirConfigComponent,
    UserConfigComponent,
    FlightlistComponent,
    AirManagementComponent,
    AmadeusComponent,
    BookingMenuListComponent,
    BookingComponent,
    PaymentConfigComponent,
    DataEncryptionComponent,
    DataSecurityComponent,
    PaymentMediumComponent,
    PaymentDepositsComponent,
    HotelComponent,
    ReportingConfigComponent,
    PaymentDetailsComponent,
    CommercialsComponent,
    TestComponent,
    FaresRulesConfigComponent,
    ManageCartsComponent,
    ModifyCartComponent,
    CartStatusComponent,
    HotelListComponent,
    RbdComponent,
    HotelDetailsComponent,
    IataCommissionComponent,
    MulitiCityFlightlistComponent,
    PnrRetriveComponent,
    ManualCartComponent,
    MealsComponent,
    HotelBookingComponent,
    MilesComponent,
    HotelPaymentDetailComponent,
    GeneratePnrComponent,
    ResetPasswdComponent,
    AirportsComponent,
    RaisedTicketComponent,
    ManualBookingComponent,
    ManualPaymentDetailComponent,
    BranchComponent,
    // HotelConfigComponent,
    AgentDashboardComponent,
    OffersComponent,
    AgentPaymentConfirmComponent,
    AgentPaymentCancelComponent,
    HotelModifyCartComponent,
    MmtRoomDetailComponent,
    AgodaRoomDetailComponent,
    MergeHotelDetailComponent,
    HotelCommercialsComponent,
    ManageFileUploadComponent,
    TripComponent,
    DocSopComponent,
    DocPolicyComponent,
    TripSummaryComponent,
    ManageExpenceComponent,
    ApproverDashboardComponent,
    ApprovalTripComponent,
    CalendarCartComponent,
    // ServicesTabsComponent,
    IntlFlightListComponent,
    TripSearchRequestComponent,
    BusComponent,
    HotelManualCartComponent,
    BusinessGroupComponent,
    // GilpinVisaComponent,
    // AirQueueComponent,
    TravelPoliciesComponent,
    TravelDeskComponent,
    HotelManualBookingComponent,
    HotelManualPaymentDetailComponent,
    HotelManagementComponent,
    TagsCardComponent,
    // MultiCityFlightlistComponent,
    DropDownComponent,
    InsuranceComponent,
    InsuranceListComponent,
    NotificationSettingsComponent,
    InsuranceCommercialsComponent,
    InsuranceBookingComponent,
    InsurancePaymentDetailComponent,
    PaymentContractComponent,
    InsuranceModifyCartComponent,
    
  ],
  imports: [
    ScrollingModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    AngularEditorModule,
    NgbModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatBadgeModule,
    MatButtonModule,
    MatCardModule,
    HttpClientModule,
    MaterialModule,
    SidebarModule,
    ButtonModule,
     RippleModule,
      AvatarModule,
       StyleClassModule,
       FileUploadModule,
       AutoCompleteModule,
       FloatLabelModule,
       DialogModule,
       OverlayPanelModule,
       RatingModule,
       CheckboxModule,
       SliderModule,
       KeyFilterModule,
       SkeletonModule,
       InfiniteScrollModule,
       ProgressSpinnerModule,
       GoogleMapsModule,
       DataViewModule,
       DockModule,
       TabViewModule,
       CardModule,
       CarouselModule,
       QRCodeModule,
       TooltipModule,
       CalendarModule,
       NgxMatDatetimePickerModule,
       NgxMatTimepickerModule,
       NgxMatNativeDateModule,
       TableModule,
       ToolbarModule,
       SplitterModule,
       MenuModule,
       AvatarGroupModule,
       BadgeModule,
       DropdownModule,
       NgxMaterialTimepickerModule,
       NgSelectModule
  ],
  providers: [
    AppHttpInterceptorService,
    AppInitializerService,
    UserInfoService,
    {
      provide: HTTP_INTERCEPTORS,
    useClass: AppHttpInterceptorService,
    multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory : initializeApp,
      deps : [UserInfoService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
